import { api } from '@/plugins/axios.js'
import store from '@/store/store'

export default {
  /**
   *
   * @param {Number} ibge - IBGE do município
   * @param {Boolean} comOpcaoSemEquipe - Parâmetro para identificar se deve adicionar a opção SEM EQUIPE no array
   * @returns Array
   */
  async getEquipes(ibge, comOpcaoSemEquipe) {
    try {
      let equipes = []
      let response = await api.get('/app/equipes/' + ibge)
      if (response) {
        equipes = response.data
        if (comOpcaoSemEquipe) {
          equipes.push({
            nu_ine: 'sem-equipe',
            no_equipe: 'SEM EQUIPE',
          })
        }
      }
      return equipes
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * Carrega as microáreas da equipe via store
   * @param {String} nu_ine
   */
  carregarMicroAreasPorEquipeLocal(nu_ine) {
    let data = []
    let microAreas = store.state.microAreas
    if (microAreas != null) {
      data = microAreas
        .filter((item) => {
          return item.ine_fci === nu_ine
        })
        .map((item) => ({ micro_area: item.micro_area }))
    }
    return data
  },
}
